<template>
  <div class="advertisement-con">
    <van-swipe class="advertisement-swipe" :autoplay="3000" indicator-color="#999" :width="swipeWidth">
      <van-swipe-item v-for="(item, i) in adList" :key="i" @click="adClick(item)">
        <img class="advertisement-swipe-img" :src="item.filePath+'?imageView2/0/w/700/h/250'" alt="">
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { mapGetters} from 'vuex';
import { listAd, listNav, tipsList } from '@/api/mall/mallContent'
import { columnDetail, courseDetail, directDetail } from '@/api/mall/mallGoods'
export default {
  components:{
  },
  props: {
    reqData: {
      required:false,
      default: {}
    }
  },
  data(){
    return {
      swipeWidth: window.screen.width || 375,
      swipeHeight: (window.screen.width>375) ? 200 : 174,
      adList: [],

    }
  },
  created(){
    this.get_AD_and_Nav()
  },
  methods: {
    get_AD_and_Nav() {
      let req = Object.assign({}, this.reqData)
      !req.adType && (req.adType = 'SYS');
      req.clientType = "H5";
      listAd(req).then(res => { //获取广告
        this.adList = res.data
      });
    },
    // 点击广告时：
    adClick(item){
      // console.log(item)
      switch (item.targetType){
        case 1: // 1-平台类目1级
        case 2: // 2-平台类目2级
        case 3: // 3-平台类目3级
          this.goCategoryMore({title: item.title, categoryId: item.targetId, level: item.targetType})
          this.$emit('pageReload')
          break;
        case 4: // 4-店铺  跳转至店铺
          this.$router.push({name: 'mallShop', query: {shopId: item.targetId} })
          break;
        case 5: // 5-商品-课程
          this.getColumnDetail(item.targetId)
          break;
        case 6: // 6-商品-专栏
          this.getColumnDetail(item.targetId)
          break;
        case 7: // 7-商品-直播
          this.getDirectDetail(item.targetId)
          break;
        case 101: // 101-省购商品平台类目1级(targetId为类目ID)；
          this.$store.dispatch('app/change_categorySysId', [item.targetId, '', ''])
          this.$router.push({name: 'sgGoodsList', query: { categoryLevel: 1, parentId: item.targetId }})
          // this.$emit('pageReload')
          break;
        case 102: // 102-省购商品平台类目2级(targetId为类目ID)；
          this.$store.dispatch('app/change_categorySysId', ['', item.targetId, ''])
          this.$router.push({name: 'sgGoodsList', query: { categoryLevel: 2, parentId: item.targetId }})
          // this.$emit('pageReload')
          break;
        case 103: // 103-省购商品平台类目3级(targetId为类目ID)；
          // let categoryLevel = item.targetType===101 ? 1 : item.targetType===102 ? 2 : item.targetType===103 ? 3 : ''
          // this.$router.push({name: 'sgGoodsList', query: {parentId: item.targetId, categoryLevel} })
          this.$store.dispatch('app/change_categorySysId', ['', '', item.targetId])
          this.$router.push({name: 'sgGoodsList', query: { categoryLevel: 3, parentId: item.targetId }})
          // this.$emit('pageReload')
          break;
        case 104: // 104-省购店铺；
          this.$router.push({name: 'sgShopIndex', query: {shopId: item.targetId} })
          break;
        case 105: // 105-省购商品；
          this.$router.push({name: 'jdGoodsDetail', query: {goodsId: item.targetId} })
          break;
        case 110: // 110-京东省购首页(targetId为null)
          this.$router.push({name: 'sgGoodsList', query: {parentId: null, categoryLevel: null} })
          break;
        case 140: // 140-开分销店(targetId为null)
          this.$dialog.confirm({
            title: '提示',
            message: '此功能请在APP中使用，是否前往下载？'
          }).then(() => {
            this.$router.push({name: 'h5Register', query: {inviteUserId: this.session('userOpenId')} })
          }).catch(() => {});
          break;
        case 141: // 141-金币抵扣专区(targetId为null)
          this.$router.push({name: 'sgCoinGoods'})
          break;
        case 142: // 142-营销活动byKey(targetId为活动KEY：SPRING_FESTIVAL-年货专区)
          this.$router.push({name: 'newActivity'})
          break;
        default:
          // this.$dialog({
          //   title: '提示',
          //   message: '功能开发中，敬请期待！'
          // })
          console.error('未定义的跳转类型')
          break;
      }
    },
    goCategoryMore(category){
      console.log(category)
      this.session('category', category)
      this.$router.push({name: 'categoryMore'})
    },
    getColumnDetail(goodsId) { // 专栏详情
      columnDetail({goodsId}).then(res=>{
        this.$router.push({name: 'goodsDetail', query: {goodsId: res.data.goodsId, shopId: res.data.shopId, courseType: null } })
      })
    },
    getCourseDetail(goodsId) { // 课程详情(视频，音频)
      courseDetail({goodsId}).then(res=>{
        this.$router.push({name: 'goodsDetail', query: {goodsId: res.data.goodsId, shopId: res.data.shopId, courseType: res.data.type } })
      })
    },
    getDirectDetail(goodsId) { // 直播详情
      directDetail({goodsId}).then(res=>{
        this.$router.push({name: 'goodsDetail', query: {goodsId: res.data.goodsId, shopId: res.data.shopId, courseType: res.data.courseType } })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.advertisement-con{
  padding: 0 12px;
  .advertisement-swipe{
    border-radius: 5px;
    z-index: 10;
    width: 351px;
    height: 175px;
    .advertisement-swipe-img{
      width: 100%;height: 100%;
    }
  }
}
</style>